<template>
    <div style="display: flex;">
        <div class="img-container">
            
            <!-- <img class="logo" sc="../../assets/logo_allfood_escrita_branca.png" alt=""> -->
            <img class="logo" :src="logo" alt="">
        </div>

        <div class="row">

            <div class="titulo-area">
                <img v-if="icone" :src="icone" :style="{ filter: corImagem }" class="ic-icone" alt="" />
                <h4>{{ titulo }}</h4>
            </div>

            <button v-if="onPressedClose" class="btn-fechar-top" @click="onPressedClose" style="margin-inline: var(--padding-padrao);">
                <img src="../../assets/icons/close-red-50.png" alt="fechar" />
            </button>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapState } from 'vuex';
import { CONSOLOGAR } from '../Controle/debug';
import { setarCores } from '@/utils/SetarCores';
export default {
    name: "MenuTopTemplate",
    props: {
        titulo: String,
        icone: String,
        onPressedClose: Function,
    },
    data() {
        return {
            numeroDeIensCarrinho: 0,
            precoTotalAteAgora: 0.0,
            logo: this.$store.state.logo,
            mesaOuCartao: this.$store.state.porCartao ? "COMANDA" : "MESA",
            corImagem: this.$store.state.corTexto === 'black' ? 'invert(0%)' : 'invert(100%)',
        };
    },
    computed: {
        ...mapState([
            'itensCarrinho'
        ]),
        numeroMesa() {
            if (this.$store.state.porCartao) {
                return "";
            }
            else {
                return this.$store.state.mesa;
            }
        },
        podeVerConta() {
            if (this.$store.state.itensCarrinho.length > 0) {
                return true; 
            }
            return false;
        },
    },
    created() {
        this.calcularPrecoTotal();
        setarCores(this.$store.state.cor1, this.$store.state.cor2,this.$store.state.corTexto)
    },
    methods: {
        clicouCarrinho() {
            CONSOLOGAR(["clicou"]);
        },
        calcularPrecoTotal() {
            for (var i = 0; i < this.itensCarrinho.length; i++) {
                this.precoTotalAteAgora = this.precoTotalAteAgora + parseFloat(this.itensCarrinho[i].precoTotal);
            }
        },
        alertarVerConta() {
            if (this.podeVerConta) {
                Swal.fire({ title: "Desculpe!", text: "Você não poderá ver a conta enquanto houver itens no carrinho de compras." });
            }
        }
    },
    components: {  }
}
</script>

<style scoped>


.row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--gradiente-btn-conta);
    /* background: blue; */
    /* background: linear-gradient(
        to bottom,
        var(--cor1) 60%,
        var(--cor1-muito-escura)
    ); */
}

.img-container {
    width: 25vw;
    height: var(--altura-menu-padrao);
    background: var(--cor1-muito-escura);
}

.logo {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    max-width: 80%;
    max-height: 80%;
    border-radius: 3px;
}

.titulo-area {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 10px;
    height: var(--altura-menu-padrao);
    padding-inline: 15px;
    animation: titulo-anim 0.5s forwards;
}

.titulo-area > h4 {
    color: var(--cor-texto);
    font-size: 12px;
    font-weight: 900;
    margin: 0;
}

.ic-icone {
    height: 22px;
}

.ic-carrinho {
  height: 25px;
}

@keyframes titulo-anim {
    from { opacity: 0;}
    to { opacity: 1;}
}





</style>